// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/data/common/svg/server.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/data/common/svg/music.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/data/common/svg/file-alt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/data/common/svg/image-square.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/data/common/svg/file.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/data/common/svg/three-dots.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  width: 100%;
  justify-content: center;
  display: flex;
  line-height: 1.4;
}

.page .button {
  font-size: var(--font-size-normal);
  padding: 0.2em 0.5em;
}

.pageInner {
  width: 100%;
  margin: 40px;
  @media (max-width: 600px) {
    & {
      width: calc(100% - 30px);
    }
  }
}

.pageInner > h1:first-child,
.pageInner > h2:first-child,
.pageInner > h3:first-child,
.pageInner > h4:first-child {
  margin-top: 0;
}

.settingsTitle {
  margin-bottom: 4px;
}

.settingsSubtitle {
  color: var(--text-border);
  margin: 0 0 35px;
}

@media (min-width: 900px) {
  .pageInner {
    max-width: var(--page-max-width);
  }
}

.settingsFooterRule {
  border: none;
  border-top: 1px solid var(--light-border);
  margin: 40px 0 16px;
}

.settingsFooter {
  color: var(--text-border);
  font-size: var(--font-size-small);
  text-align: center;
}

.pageButtonList {
  flex-direction: column;
  display: flex;
  gap: 1em;
  max-width: 18em;
  margin: 3em auto;
  .button {
    padding: 0.6em;
  }
}

.settingsCard {
  border: 1px solid var(--light-border);
  border-radius: 10px;
  box-shadow:
    0px 3px 4px #0001,
    0px 2px 2px #0001;
  padding: 20px;
}

.pageInner > .settingsCard,
.pageInner > .settingsSectionHeading {
  margin-top: 20px;
}

.settingsSectionGrid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 30px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
}

.settingsSectionCard {
}

.settingsFieldset {
  border: none;
  margin: 12px 0 0;
  padding: 0;

  & legend {
    font-weight: 600;
    margin-bottom: 10px;
    padding: 0;
  }
  & input:not(:first-child) {
    margin-inline-start: 15px;
  }
}

.settingsProviderList {
  display: flex;
  flex-direction: column;

  & .button {
    padding: var(--button-big-padding);
    font-size: var(--font-size-small);
    white-space: nowrap;
  }
}

.settingsProvider {
  border-top: 1px solid var(--light-border);
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 30px;

  &:first-child {
    border: none;
  }

  h3,
  p {
    margin: 0;
  }
}

.settingsProviderNameRow {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}

.settingsProviderSummary {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 500px) {
    & {
      flex-direction: column;
      align-items: start;
      gap: 15px;
    }
  }
}

.settingsProviderTitle {
  align-items: center;
  display: flex;
  gap: 12px;
}

.settingsProviderIconTile {
  align-items: center;
  background: #f0f0f0;
  border-radius: 8px;
  display: flex;
  flex-shrink: 0;
  height: 60px;
  width: 60px;
  justify-content: center;
}

.settingsProviderIconTileAccent {
  background: #5a2cd2;
}

.settingsProviderIcon {
  flex-shrink: 0;
  height: 40px;
  width: 40px;
}

.settingsProviderIconMask {
  background-color: #fff;
  display: block;
  flex-shrink: 0;
  height: 30px;
  width: 30px;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}

.settingsProviderIconMaskServer {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.settingsSectionHeading {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  gap: 4px;
}

.settingsSectionTitleRow {
  align-items: center;
  display: flex;
  gap: 12px;
}

.settingsSectionHeading h2,
.settingsSectionHeading p {
  margin: 0;
}

.settingsSectionHeading p {
  margin-left: 52px;
  opacity: 0.7;
}

.settingsSectionIcon {
  flex-shrink: 0;
  height: 40px;
  width: 40px;
}

.settingsProviderWarning {
  padding: 1em;
  margin: 1em;
  background: #fe3131;
  color: #fff;
  border: 1px solid #b00000;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pageBeta {
  text-transform: uppercase;
  margin: 0 0.5em;
  font-size: 0.5em;
  padding: 0.6em 0.5em 0.5em;
  display: inline-block;
  background: #ccc;
  border-radius: 0.5em;
  line-height: 0.7;
  position: relative;
  top: -0.3em;
}

.pageExperimental {
  background: #f5a623;
  color: #fff;
}

.pageButtonBeta {
  text-transform: uppercase;
  margin: 0 0.5em;
  font-size: 0.5em;
  padding: 0.6em 0.5em 0.5em;
  display: inline-block;
  background: #ccc;
  border-radius: 0.5em;
  line-height: 0.7;
  position: relative;
  top: -0.1em;
  color: var(--primary-color);
  font-weight: bold;
  font-size: 0.7em;
}

.storeCache {
  background-color: #eee;
  border: 1px solid #ddd;
  border-radius: 4px;
  grid-column: 1 / -1;
  padding: 8px;
}

.storeCacheSummary {
  align-items: center;
  display: flex;
}

.storeCacheToggle {
  align-items: center;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  flex: 1;
  font: inherit;
  gap: 10px;
  min-width: 0;
  padding: 0;
  text-align: left;
}

.storeCacheTitle {
  font-weight: 600;
  white-space: nowrap;
}

.storeCacheSummaryText {
  flex: 0 0 6em;
  opacity: 0.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.storeCacheBar {
  background-color: #ddd;
  border-radius: 5px;
  display: flex;
  flex: 1 1 0;
  height: 10px;
  min-width: 40px;
  overflow: hidden;
}

.storeCacheBarSegment {
  flex-basis: 0;
  min-width: 2px;

  & + & {
    border-inline-start: 1px solid #eee;
  }
}

.storeCacheBarFill {
  background-color: var(--storeCacheCategoryColor);
  flex: 1;
}

.storeCacheBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0 0 24px;
}

.storeCacheOptions {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.storeCacheOption {
  align-items: center;
  display: flex;
  gap: 8px;

  & input {
    margin: 0;
  }
}

.storeCacheMessage {
  margin: 0;
  opacity: 0.7;
}

.storeCacheTable {
  border-collapse: collapse;
  width: 100%;

  & tr + tr {
    border-top: 1px solid #ddd;
  }

  & th,
  & td {
    font-weight: normal;
    padding: 6px 0;
    text-align: left;
  }

  & th {
    width: 50%;
  }
}

.storeCacheCategoryIconCell {
  width: 28px;
}

.storeCacheCategoryIcon {
  background-color: var(--storeCacheCategoryColor);
  display: block;
  height: 18px;
  mask-image: var(--storeCacheCategoryIcon);
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  width: 18px;
}

.storeCacheCategoryDot {
  background-color: var(--storeCacheCategoryColor);
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-inline-end: 8px;
  width: 10px;
}

.storeCachePercent {
  opacity: 0.7;
}

.storeCacheCategory-audio {
  --storeCacheCategoryColor: #6d3cf0;
  --storeCacheCategoryIcon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.storeCacheCategory-text {
  --storeCacheCategoryColor: #2f80ed;
  --storeCacheCategoryIcon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.storeCacheCategory-images {
  --storeCacheCategoryColor: #27a35a;
  --storeCacheCategoryIcon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.storeCacheCategory-pdf {
  --storeCacheCategoryColor: #f2994a;
  --storeCacheCategoryIcon: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.storeCacheCategory-other {
  --storeCacheCategoryColor: #7b7f8e;
  --storeCacheCategoryIcon: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Page.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;IACE;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB;;qBAEmB;EACnB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,gBAAgB;;EAEhB;IACE,0BAA0B;EAC5B;AACF;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;;EAEV;IACE,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,kCAAkC;IAClC,iCAAiC;IACjC,mBAAmB;EACrB;AACF;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;;EAEb;IACE,YAAY;EACd;;EAEA;;IAEE,SAAS;EACX;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,WAAW;;EAEX;IACE;MACE,sBAAsB;MACtB,kBAAkB;MAClB,SAAS;IACX;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mDAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,OAAO;EACP,aAAa;EACb,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;;EAEd;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,gDAAgD;EAChD,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;;EAER;IACE,SAAS;EACX;AACF;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;;EAEX;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,cAAc;EACd,YAAY;EACZ,yCAAyC;EACzC,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,iEAA2D;AAC7D;;AAEA;EACE,kCAAkC;EAClC,iEAA8D;AAChE;;AAEA;EACE,kCAAkC;EAClC,iEAAkE;AACpE;;AAEA;EACE,kCAAkC;EAClC,iEAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,iEAAgE;AAClE","sourcesContent":[".page {\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  line-height: 1.4;\n}\n\n.page .button {\n  font-size: var(--font-size-normal);\n  padding: 0.2em 0.5em;\n}\n\n.pageInner {\n  width: 100%;\n  margin: 40px;\n  @media (max-width: 600px) {\n    & {\n      width: calc(100% - 30px);\n    }\n  }\n}\n\n.pageInner > h1:first-child,\n.pageInner > h2:first-child,\n.pageInner > h3:first-child,\n.pageInner > h4:first-child {\n  margin-top: 0;\n}\n\n.settingsTitle {\n  margin-bottom: 4px;\n}\n\n.settingsSubtitle {\n  color: var(--text-border);\n  margin: 0 0 35px;\n}\n\n@media (min-width: 900px) {\n  .pageInner {\n    max-width: var(--page-max-width);\n  }\n}\n\n.settingsFooterRule {\n  border: none;\n  border-top: 1px solid var(--light-border);\n  margin: 40px 0 16px;\n}\n\n.settingsFooter {\n  color: var(--text-border);\n  font-size: var(--font-size-small);\n  text-align: center;\n}\n\n.pageButtonList {\n  flex-direction: column;\n  display: flex;\n  gap: 1em;\n  max-width: 18em;\n  margin: 3em auto;\n  .button {\n    padding: 0.6em;\n  }\n}\n\n.settingsCard {\n  border: 1px solid var(--light-border);\n  border-radius: 10px;\n  box-shadow:\n    0px 3px 4px #0001,\n    0px 2px 2px #0001;\n  padding: 20px;\n}\n\n.pageInner > .settingsCard,\n.pageInner > .settingsSectionHeading {\n  margin-top: 20px;\n}\n\n.settingsSectionGrid {\n  display: grid;\n  gap: 30px;\n  grid-template-columns: repeat(2, 1fr);\n  margin-top: 30px;\n\n  @media (max-width: 700px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.settingsSectionCard {\n}\n\n.settingsFieldset {\n  border: none;\n  margin: 12px 0 0;\n  padding: 0;\n\n  & legend {\n    font-weight: 600;\n    margin-bottom: 10px;\n    padding: 0;\n  }\n  & input:not(:first-child) {\n    margin-inline-start: 15px;\n  }\n}\n\n.settingsProviderList {\n  display: flex;\n  flex-direction: column;\n\n  & .button {\n    padding: var(--button-big-padding);\n    font-size: var(--font-size-small);\n    white-space: nowrap;\n  }\n}\n\n.settingsProvider {\n  border-top: 1px solid var(--light-border);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 30px;\n\n  &:first-child {\n    border: none;\n  }\n\n  h3,\n  p {\n    margin: 0;\n  }\n}\n\n.settingsProviderNameRow {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.settingsProviderSummary {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 500px) {\n    & {\n      flex-direction: column;\n      align-items: start;\n      gap: 15px;\n    }\n  }\n}\n\n.settingsProviderTitle {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.settingsProviderIconTile {\n  align-items: center;\n  background: #f0f0f0;\n  border-radius: 8px;\n  display: flex;\n  flex-shrink: 0;\n  height: 60px;\n  width: 60px;\n  justify-content: center;\n}\n\n.settingsProviderIconTileAccent {\n  background: #5a2cd2;\n}\n\n.settingsProviderIcon {\n  flex-shrink: 0;\n  height: 40px;\n  width: 40px;\n}\n\n.settingsProviderIconMask {\n  background-color: #fff;\n  display: block;\n  flex-shrink: 0;\n  height: 30px;\n  width: 30px;\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n}\n\n.settingsProviderIconMaskServer {\n  mask-image: url('/data/common/svg/server.svg');\n}\n\n.settingsSectionHeading {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n  gap: 4px;\n}\n\n.settingsSectionTitleRow {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.settingsSectionHeading h2,\n.settingsSectionHeading p {\n  margin: 0;\n}\n\n.settingsSectionHeading p {\n  margin-left: 52px;\n  opacity: 0.7;\n}\n\n.settingsSectionIcon {\n  flex-shrink: 0;\n  height: 40px;\n  width: 40px;\n}\n\n.settingsProviderWarning {\n  padding: 1em;\n  margin: 1em;\n  background: #fe3131;\n  color: #fff;\n  border: 1px solid #b00000;\n  border-radius: 3px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pageBeta {\n  text-transform: uppercase;\n  margin: 0 0.5em;\n  font-size: 0.5em;\n  padding: 0.6em 0.5em 0.5em;\n  display: inline-block;\n  background: #ccc;\n  border-radius: 0.5em;\n  line-height: 0.7;\n  position: relative;\n  top: -0.3em;\n}\n\n.pageExperimental {\n  background: #f5a623;\n  color: #fff;\n}\n\n.pageButtonBeta {\n  text-transform: uppercase;\n  margin: 0 0.5em;\n  font-size: 0.5em;\n  padding: 0.6em 0.5em 0.5em;\n  display: inline-block;\n  background: #ccc;\n  border-radius: 0.5em;\n  line-height: 0.7;\n  position: relative;\n  top: -0.1em;\n  color: var(--primary-color);\n  font-weight: bold;\n  font-size: 0.7em;\n}\n\n.storeCache {\n  background-color: #eee;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  grid-column: 1 / -1;\n  padding: 8px;\n}\n\n.storeCacheSummary {\n  align-items: center;\n  display: flex;\n}\n\n.storeCacheToggle {\n  align-items: center;\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  display: flex;\n  flex: 1;\n  font: inherit;\n  gap: 10px;\n  min-width: 0;\n  padding: 0;\n  text-align: left;\n}\n\n.storeCacheTitle {\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.storeCacheSummaryText {\n  flex: 0 0 6em;\n  opacity: 0.7;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.storeCacheBar {\n  background-color: #ddd;\n  border-radius: 5px;\n  display: flex;\n  flex: 1 1 0;\n  height: 10px;\n  min-width: 40px;\n  overflow: hidden;\n}\n\n.storeCacheBarSegment {\n  flex-basis: 0;\n  min-width: 2px;\n\n  & + & {\n    border-inline-start: 1px solid #eee;\n  }\n}\n\n.storeCacheBarFill {\n  background-color: var(--storeCacheCategoryColor);\n  flex: 1;\n}\n\n.storeCacheBody {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 8px 0 0 24px;\n}\n\n.storeCacheOptions {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n}\n\n.storeCacheOption {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n\n  & input {\n    margin: 0;\n  }\n}\n\n.storeCacheMessage {\n  margin: 0;\n  opacity: 0.7;\n}\n\n.storeCacheTable {\n  border-collapse: collapse;\n  width: 100%;\n\n  & tr + tr {\n    border-top: 1px solid #ddd;\n  }\n\n  & th,\n  & td {\n    font-weight: normal;\n    padding: 6px 0;\n    text-align: left;\n  }\n\n  & th {\n    width: 50%;\n  }\n}\n\n.storeCacheCategoryIconCell {\n  width: 28px;\n}\n\n.storeCacheCategoryIcon {\n  background-color: var(--storeCacheCategoryColor);\n  display: block;\n  height: 18px;\n  mask-image: var(--storeCacheCategoryIcon);\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n  width: 18px;\n}\n\n.storeCacheCategoryDot {\n  background-color: var(--storeCacheCategoryColor);\n  border-radius: 50%;\n  display: inline-block;\n  height: 10px;\n  margin-inline-end: 8px;\n  width: 10px;\n}\n\n.storeCachePercent {\n  opacity: 0.7;\n}\n\n.storeCacheCategory-audio {\n  --storeCacheCategoryColor: #6d3cf0;\n  --storeCacheCategoryIcon: url('/data/common/svg/music.svg');\n}\n\n.storeCacheCategory-text {\n  --storeCacheCategoryColor: #2f80ed;\n  --storeCacheCategoryIcon: url('/data/common/svg/file-alt.svg');\n}\n\n.storeCacheCategory-images {\n  --storeCacheCategoryColor: #27a35a;\n  --storeCacheCategoryIcon: url('/data/common/svg/image-square.svg');\n}\n\n.storeCacheCategory-pdf {\n  --storeCacheCategoryColor: #f2994a;\n  --storeCacheCategoryIcon: url('/data/common/svg/file.svg');\n}\n\n.storeCacheCategory-other {\n  --storeCacheCategoryColor: #7b7f8e;\n  --storeCacheCategoryIcon: url('/data/common/svg/three-dots.svg');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
